import { alpha, toggleButtonClasses } from '@mui/material'

import { createConfiguratorTheme, desktopStyles } from '@salsita-ai/platform-project-sdk/ui'

export const BRAND_PRIMARY_COLOR = '#5A87C6'

export const metalworksTheme = createConfiguratorTheme({
  typography: {
    fontFamily: ['Futura BT', 'sans-serif'].join(','),
    fontWeightRegular: 400,
    fontSize: 16,
    h4: {
      fontSize: '1.875rem',
      fontWeight: 700,
      lineHeight: '2.3rem',
      letterSpacing: '0.25px',
      ...desktopStyles({
        fontSize: '1.875rem',
        fontWeight: 700,
        lineHeight: '2.3rem',
        letterSpacing: '0.25px',
      }),
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 700,
      lineHeight: '1.75rem',
      letterSpacing: '0.15px',
      ...desktopStyles({
        fontSize: '1.25rem',
        fontWeight: 700,
        lineHeight: '1.75rem',
        letterSpacing: '0.15px',
      }),
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: '1.4rem',
      letterSpacing: '0.15px',
    },
    body2: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: '1.25rem',
      letterSpacing: '0.17px',
    },
    caption: {
      fontSize: '0.75rem',
      fontWeight: 400,
      lineHeight: '0.975rem',
      letterSpacing: '0.1px',
    },
  },
  palette: {
    primary: {
      main: alpha('#000', 0.87),
    },
    secondary: {
      main: alpha('#000', 0.6),
    },
    action: {
      selected: '#000',
    },
    background: {
      scene: '#DEDEDE',
      default: '#F7F7F7',
      paper: '#FFF',
    },
    warning: {
      main: '#FF964F',
    },
  },
  shape: {
    borderRadius: 0,
    sidebarBorderRadius: 0,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          paddingBlock: theme.spacing(1.5),
          paddingInline: theme.spacing(3),
        }),
        containedPrimary: ({ theme }) => ({
          '&:hover': {
            backgroundColor: theme.palette.primary.light,
          },
        }),
      },
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: ({ theme }) => ({
          padding: theme.spacing(4),
        }),
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: ({ theme }) => ({
          padding: theme.spacing(3),
          paddingTop: 0,
        }),
      },
    },
    MuiCardMedia: {
      styleOverrides: {
        img: () => ({
          objectFit: 'contain',
          maxHeight: '95%',
          maxWidth: '95%',
        }),
      },
    },
    PhxDesktopBrandingPoweredBy: {
      defaultProps: {
        visible: false,
      },
    },
    PhxMobileBrandingPoweredBy: {
      defaultProps: {
        visible: false,
      },
    },
    PhxEntityHeader: {
      defaultProps: {
        titleVariant: 'h4',
      },
    },
    PhxPresetScreen: {
      defaultProps: {
        // Default is h4, but setting anyway to prevent changes from the SDK.
        // (change requested by the client)
        headingVariant: 'h4',
      },
      styleOverrides: {
        heading: {
          marginBottom: '1em',
          fontWeight: '400 !important',
        },
      },
    },
    PhxSidebarPanel: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.default,
        }),
        padding: ({ theme }) => ({
          padding: theme.spacing(2.5),
        }),
        footer: ({ theme }) => ({
          boxShadow: `0px -1px 8px 0px ${alpha(theme.palette.text.primary, 0.08)}`,
          backgroundColor: theme.palette.background.paper,
        }),
      },
    },
    PhxTabNavigation: {
      defaultProps: {
        variant: 'square',
      },
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.default,
        }),
        tab: {
          '& > span': {
            whiteSpace: 'break-spaces',
            wordBreak: 'break-word',
          },
        },
      },
    },
    PhxDisabledOverlay: {
      defaultProps: {
        icon: 'Info',
        placement: 'corner',
      },
    },
    PhxToggleSelectorItem: {
      defaultProps: {
        variant: 'contained',
      },
      styleOverrides: {
        button: {
          [`&.${toggleButtonClasses.selected}`]: {
            border: `1px solid ${BRAND_PRIMARY_COLOR} !important`,
          },
        },
      },
    },
  },
})
